import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private spinnerVisible = new BehaviorSubject<boolean>(false);
  spinnerVisible$ = this.spinnerVisible.asObservable();

  // Show the spinner
  showSpinner(): void {
    this.spinnerVisible.next(true);
  }

  // Hide the spinner
  hideSpinner(): void {
    this.spinnerVisible.next(false);
  }
}
